<!-- <div (click)="closeErrorEvent()" id="closeBtn" class="btn btn-size_normal btn-primary font-lg-medium-big m-x-auto">
      Please Try Again</div> -->
<!-- </div> -->
<!-- <div class="leftpart__image leftpart__image_big">
        <img id="imgg" src="../../../assets/images/image@3x.png')" alt="" loading="lazy" />
    </div>
    <div class="main__rightpart">
        <div class="main__rightpart_sory-gray-block">
            <div class="flex-container">
                <div class="text-cont main__rightpart_sory-gray-block">
                    <div id="rHeader" class="rightpart__header rightpart__header_bg-orange header-smaller">
                        Please note…
                    </div>
                    <span id="oops">This might take a minute,<br />
            have a cup of coffee…</span
          >
          <span id="itus"
            >We’re experiencing technical difficulties, but no worries!<br />
            We’ve saved your place and we’ll update you at<br />
            <span class="fw-bold"> xxx-xxx-1234</span> on when you may continue your application.</span>
                    <div (click)="close()" id="closeBtn" class="btn btn-size_normal btn-primary font-lg-medium-big m-x-auto">
                        Remind Me Later
                    </div>
                </div>
            </div>
        </div>
    </div> -->
<!-- <div class="modal__main">  
        <div class="leftpart__image leftpart__image_big">
            <img id="imgg" src="../../../assets/images/image@3x.png')" alt="" loading="lazy" />
        </div>
        <div class="main__rightpart" >
        <div id="rHeader" class="rightpart__header rightpart__header_bg-orange header-smaller">Please note…</div>
        <div class="text-cont main__rightpart_sory-gray-block">
            <span id="oops">This might take a minute,<br />
        have a cup of coffee…</span
      >
      <span id="itus"
        >We’re experiencing technical difficulties, but no worries!<br />
        We’ve saved your place and we’ll update you at<br />
        <span class="fw-bold"> xxx-xxx-{{mobileNumber.slice(-4)}}</span> on when you may continue your application.</span>
        </div>
        <div (click)="close" id="closeBtn" class="btn btn-size_normal btn-primary font-lg-medium-big m-x-auto">
            Remind Me Later
        </div>
    </div>
  </div> -->
<div class="modal__main">
  <div class="main__leftpart" style="min-width: 47%;">
    <div class="leftpart__image leftpart__image_big">
      <img src="../../../assets/images/partner-down.png'" alt="" loading="lazy" />
    </div>
  </div>
  <div class="main__rightpart" style="background-color: #f3f3f3; color: #111;">
    <div class="rightpart__header rightpart__header_bg-orange header-xs-smaller font-lg-bigger">
      Please note...
    </div>
    <div class="text-cont"
    >
      <div style="font-size: 2.4em;
      margin-top: 2.75em;
      line-height: 1.18;" id="oops"
        >This might take a minute,<br />
        have a cup of coffee…</div
      >
      <div style="font-size: 1.1em;
      margin-top: 2.5em;
      line-height: 1.21;" id="itus"
        >We’re experiencing technical difficulties, but no worries!<br />
        We’ve saved your place and we’ll update you at<br />
        <span class="fw-bold"> xxx-xxx-{{ mobileNumber.slice(-4) }}</span> on when you may continue your
        application.</div
      >
    </div>
    <div (click)="close()" style="margin: auto auto 2em;" id="closeBtn" class="btn btn-size_normal btn-primary font-lg-medium-big ">
      Remind Me Later
    </div>
  </div>
</div>

<!-- <div class="modal__main">
  <div class="main__leftpart">
    <div class="leftpart__image leftpart__image_big">
      <img src="../../../assets/images/dent-and-pony.jpg')" alt="" loading="lazy" />
    </div>
  </div>
  <div class="mainRightPartExceptionFlow main__rightpart border-xs-gray">
    <div class="rightpart__header rightpart__header_bg-orange header-xs-smaller font-lg-bigger">
      We need more information
    </div>
    <div class="exceptionFlowGroupA flex-column a-items-center m-y-xs-regular m-y-xs-large p-y-lg-big">
      <span class="icon icon_giant icon_support m-b-xs-small m-b-xs-big m-b-lg-medium-big"></span>
      <div style="color: #333333" class="font-xs-medium font-lg-medium-big p-x-xs-regular">
        Before we can show you loan options, please provide a bit more info.<br />For your security, the info
        must be submitted via the iCreditWorks App.
      </div>
    </div>
    <div class="modalFooterExceptionFlow modal__footer">
      <div class="footer-text border_bottom">
        <div class="column-lg-90">
          <span class="font-weight-bold">Click submit</span> and we’ll text you a secure link to download<br />
          the <span class="font-weight-bold">iCreditWorks App</span> to complete your loan application.
        </div>
      </div>
      <div class="flex-row j-content-between p-t-medium">
        <div
          id="appLinkInputModalDiv"
          *ngIf="!breakpoints.extraSmall"
          class="modal__input column-xs-45 column-lg-40 phone-number input-area__inactive"
          (click)="inputItemClick($event)"
        >
          <span class="mobPhoneSpan font-color-gray">Mobile #</span>
          <input
            id="appLinkInputModal"
            maxlength="12"
            (input)="onMobileInput($event)"
            class="mobile-input"
            type="text"
            placeholder=""
          />
        </div>
        <div
          id="appLinkInputModalDiv"
          *ngIf="breakpoints.extraSmall"
          class="modal__input column-xs-45 column-lg-40 phone-number input-area__inactive"
          (click)="inputItemClick($event)"
        >
          <span class="font-color-gray">Mobile #</span>
          <input
            id="appLinkInputModal"
            maxlength="12"
            (input)="onMobileInput($event)"
            class="mobile-input"
            type="text"
            placeholder=""
          />
        </div>
        <div
          class="btnSizeNrm btn btn-size_normal btn-white btn-white_animation column-xs-45 column-lg-30"
          (click)="toSendAppLinkEvent($event)"
        >
          Submit
        </div>
      </div>
    </div>
  </div>
</div> -->
